import { Component, OnInit, OnDestroy } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { InvoiceMemoryImportService, InvoiceImportStatus } from '../../services/invoice-memory-import.service';

@Component({
  selector: 'app-invoice-memory-import',
  templateUrl: './invoice-memory-import.component.html',
  styleUrls: ['./invoice-memory-import.component.scss']
})
export class InvoiceMemoryImportComponent implements OnInit, OnDestroy {
  status?: InvoiceImportStatus;
  busy = false;
  loading = false;
  error = '';
  loadError = '';
  offset = 0;
  private timer?: ReturnType<typeof setInterval>;
  private destroyed = false;
  constructor(private service: InvoiceMemoryImportService) {}
  ngOnInit() {
    void this.refresh();
    this.timer = setInterval(() => { void this.refresh(); }, 3000);
  }
  ngOnDestroy() { this.destroyed = true; if (this.timer) clearInterval(this.timer); }
  get progress() {
    const s = this.status;
    return s?.total ? Math.min(100, Math.round((s.saved + s.skipped + s.failed) / s.total * 100)) : 0;
  }
  get coolingDown() { return Boolean(this.status?.retryAt && new Date(this.status.retryAt).getTime() > Date.now()); }
  get quotaIssue() { return ['quota', 'credits', 'spending limit', 'usage limit'].some(term => this.status?.error?.includes(term)); }
  async refresh() {
    if (this.loading || this.destroyed) return;
    this.loading = true;
    try {
      const status = await firstValueFrom(this.service.status(this.offset));
      if (!this.destroyed) { this.status = status; this.loadError = ''; }
    } catch (error: any) { this.loadError = error?.error?.error || 'Unable to load import progress.'; }
    finally { this.loading = false; }
  }
  async act(action: 'start' | 'pause' | 'retry') {
    if (this.busy) return;
    this.busy = true;
    this.error = '';
    try {
      await firstValueFrom(action === 'pause' ? this.service.pause() : this.service.start(action === 'retry'));
      this.offset = 0;
      await this.refresh();
    } catch (error: any) { this.error = error?.error?.error || 'Unable to change the import run.'; }
    finally { this.busy = false; }
  }
  async page(direction: number) {
    if (this.loading) return;
    this.offset = Math.max(0, this.offset + direction * 20);
    await this.refresh();
  }
}
